import classnames from "classnames";

export default {
    classnames: (props: any) =>
        classnames({
            [`has-text-${props.textColor}`]: props.textColor,
            [`has-background-${props.backgroundColor}`]: props.backgroundColor,
        }),
    clean: ({
        textColor,
        backgroundColor,
        ...props
    }: {
        textColor: any;
        backgroundColor: any;
    }) => props,
};
